import { produce } from 'immer';
import * as types from './constants';

// initial state

export const initialState = {
  loading: false,
  productAplColumns: [],
  error: null,
  reloadGrid: false,
};

const productAPLReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case types.GET_PRODUCT_APL_GRID_COLUMN:
        draft.loading = true;
        draft.productAplColumns = [];
        break;
      case types.GET_PRODUCT_APL_GRID_COLUMN_SUCCESS:
        draft.loading = false;
        draft.productAplColumns = action.payload;
        break;
      case types.GET_PRODUCT_APL_GRID_COLUMN_ERROR:
        draft.loading = false;
        draft.productAplColumns = [];
        draft.error = action.payload;
        break;

      case types.TOGGLE_RELOAD_GRID_APL:
        draft.reloadGrid = true;
        break;
      case types.RESET_RELOAD_GRID_APL:
        draft.reloadGrid = false;
        break;

      default:
        break;
    }
  });

export default productAPLReducer;
